"use strict";

if (process.env.NODE_ENV === "production") {
  module.exports = require("./cjs/react-router.min.js");
} else {
  module.exports = require("./cjs/react-router.js");
}



//////////////////
// WEBPACK FOOTER
// ./~/react-router/index.js
// module id = 217
// module chunks = 0